<template>
  <v-container>
    <div class="primary--text d-flex align-center justify-space-between">
      <div class="display-2">
        {{ (getCompany.tradename || getCompany.name) | capitalizeWords }}
        <v-menu offset-y v-if="getCompanies.length > 1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              text
            >
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in getCompanies"
              :key="index"
              link
              @click="changeCompany(item)"
            >
              <v-list-item-title>{{ item.tradename || item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div  class="title">
        {{ getCompany.name | capitalizeWords }}
      </div>
    </div>
    <v-divider style="background: #F72585;"></v-divider>
    <v-row>
      <v-col cols="12"></v-col>
    </v-row>
    <v-row v-if="show">
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title>{{ 10000 | currencyFormat }}</v-card-title>
          <v-card-subtitle>Cuentas x cobrar</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="overline">Vigentes</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 2 | numberFormat }} documentos</div>
              </v-col>
              <v-col cols="6">
                <div class="overline">Vencidos</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 1 | numberFormat }} documentos</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title>{{ 10000 | currencyFormat }}</v-card-title>
          <v-card-subtitle>Cuentas x pagar</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="overline">Vigentes</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 2 | numberFormat }} documentos</div>
              </v-col>
              <v-col cols="6">
                <div class="overline">Vencidos</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 1 | numberFormat }} documentos</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title>{{ 10000 | currencyFormat }}</v-card-title>
          <v-card-subtitle>Efectivo</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="overline">Patrimonio</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 2 | numberFormat }} documentos</div>
              </v-col>
              <v-col cols="6">
                <div class="overline">Pasivo</div>
                <div class="title">{{ 5000 | currencyFormat }}</div>
                <div class="body-2">{{ 1 | numberFormat }} documentos</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>Ventas y gastos</v-card-title>
          <Chart title="Ingresos vs gastos" :data="series"></Chart>
        </v-card>
      </v-col>
    </v-row>
    <div v-else>
    <v-row v-for="(item, i) in getViews" :key="i" class="pa-1">
      <v-col cols="12" v-if="item.title !== 'Inicio'">
        <h1 class="title ">{{ item.title }}</h1>
      </v-col>
      <v-col
        v-if="item.title === 'Punto de venta' || item.title === 'Contactos'"
        cols="12"
        md="6"
        lg="4"
        xl="3"
        class="pr-12 py-4"
      >
        <v-btn
          :to="item.to"
          x-large
          class=""
          link
          color="#f3f5fb"
          elevation="0"
          :style="!isMovil ? 'width: 381px;' : 'width: 350px;'"
        >
          <i v-html="item.icon" class="mr-4" v-if="false"></i>
          <v-icon
            dark
            left
            color="quaternary"
            x-large
            class="mx-4"
            v-else
          >
            {{ item.title === 'Contactos' ? 'mdi-book-account-outline' : item.icon }}
          </v-icon>
          {{item.title}}
        </v-btn>
      </v-col>
      <v-col
        v-for="(sub, j) in item.subgroup"
        :key="j"
        cols="12"
        md="6"
        lg="4"
        xl="3"
        class="pr-12 py-3"
      >
        <v-btn
          :to="sub.to"
          x-large
          class=""
          link
          color="#f3f5fb"
          elevation="0"
          :style="!isMovil ? 'width: 381px;' : 'width: 350px;'"
        >
          <i v-html="sub.icon" class="mr-4" v-if="sub.custom"></i>
          <v-icon
            dark
            left
            color="quaternary"
            x-large
            class="mx-4"
            v-else
          >
            {{sub.icon}}
          </v-icon>
          {{sub.title}}
        </v-btn>
      </v-col>
    </v-row></div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import views from '@/assets/moduleViews'
import Chart from './Chart.vue'

export default {
  name: 'HelloWorld',

  data: () => ({
    ecosystem: [
      {
        text: 'vuetify-loader',
        href: 'https://github.com/vuetifyjs/vuetify-loader'
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify'
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify'
      }
    ],
    series: [
      {
        name: 'Ingresos',
        data: [
          [1704067200000, 2458.67],
          [1704153600000, 2467.53],
          [1704240000000, 2349.76],
          [1704326400000, 2384.67],
          [1704412800000, 2480.99],
          [1704499200000, 2452.13],
          [1704585600000, 2465.76],
          [1704672000000, 2369.67],
          [1704758400000, 2374.12],
          [1704844800000, 2437.45],
          [1704931200000, 2394.12],
          [1705017600000, 2478.67],
          [1705104000000, 2389.99],
          [1705190400000, 2408.53],
          [1705276800000, 2442.13],
          [1705363200000, 2464.76],
          [1705449600000, 2387.99],
          [1705536000000, 2398.45],
          [1705622400000, 2434.12],
          [1705708800000, 2472.67],
          [1705795200000, 2378.99],
          [1705881600000, 2490.53],
          [1705968000000, 2384.12],
          [1706054400000, 2470.76],
          [1706140800000, 2493.45],
          [1706227200000, 2354.99],
          [1706313600000, 2390.67],
          [1706400000000, 2456.12],
          [1706486400000, 2382.45],
          [1706572800000, 2364.76],
          [1706659200000, 2480.12],
          [1706745600000, 2443.67],
          [1706832000000, 2429.76],
          [1706918400000, 2398.45],
          [1707004800000, 2457.12],
          [1707091200000, 2360.53],
          [1707177600000, 2490.99],
          [1707264000000, 2438.76],
          [1707350400000, 2387.45],
          [1707436800000, 2494.12],
          [1707523200000, 2445.67],
          [1707609600000, 2346.99],
          [1707696000000, 2470.53],
          [1707782400000, 2456.67],
          [1707868800000, 2374.12],
          [1707955200000, 2399.53],
          [1708041600000, 2468.45],
          [1708128000000, 2432.99],
          [1708214400000, 2480.12],
          [1708300800000, 2443.76],
          [1708387200000, 2350.67],
          [1708473600000, 2459.12],
          [1708560000000, 2364.45],
          [1708646400000, 2487.76],
          [1708732800000, 2398.12],
          [1708819200000, 2462.67],
          [1708905600000, 2400.76],
          [1708992000000, 2476.99],
          [1709078400000, 2395.12],
          [1709164800000, 2345.53],
          [1709251200000, 2480.67],
          [1709337600000, 2454.76],
          [1709424000000, 2397.12],
          [1709510400000, 2452.45],
          [1709596800000, 2379.76],
          [1709683200000, 2394.12],
          [1709769600000, 2483.99],
          [1709856000000, 2462.53],
          [1709942400000, 2437.45],
          [1710028800000, 2490.67],
          [1710115200000, 2398.12],
          [1710201600000, 2476.99],
          [1710288000000, 2354.53],
          [1710374400000, 2447.12],
          [1710460800000, 2468.76],
          [1710547200000, 2379.99],
          [1710633600000, 2430.53],
          [1710720000000, 2474.76],
          [1710806400000, 2457.99],
          [1710892800000, 2394.12],
          [1710979200000, 2486.67],
          [1711065600000, 2365.12],
          [1711152000000, 2404.53],
          [1711238400000, 2439.76],
          [1711324800000, 2495.99],
          [1711411200000, 2463.67],
          [1711497600000, 2398.12],
          [1711584000000, 2462.45],
          [1711670400000, 2379.76],
          [1711756800000, 2447.12],
          [1711843200000, 2474.53],
          [1711929600000, 2346.45],
          [1712016000000, 2480.67],
          [1712102400000, 2394.76],
          [1712188800000, 2437.45],
          [1712275200000, 2472.99],
          [1712361600000, 2456.53],
          [1712448000000, 2398.67],
          [1712534400000, 2487.45],
          [1712620800000, 2349.99],
          [1712707200000, 2452.76],
          [1712793600000, 2374.12],
          [1712880000000, 2486.67]
        ]
      },
      {
        name: 'Gastos',
        data: [[1704067200000, 2273.04], [1704153600000, 2315.53], [1704240000000, 2272.26], [1704326400000, 2480.06], [1704412800000, 2324], [1704499200000, 2422.69], [1704585600000, 2294.79], [1704672000000, 2345.66], [1704758400000, 2274.12], [1704844800000, 2220.58], [1704931200000, 2489.88], [1705017600000, 2426.24], [1705104000000, 2366.09], [1705190400000, 2331.62], [1705276800000, 2435.82], [1705363200000, 2246.52], [1705449600000, 2356.63], [1705536000000, 2321.43], [1705622400000, 2380.8], [1705708800000, 2348.94], [1705795200000, 2392.94], [1705881600000, 2510.06], [1705968000000, 2375.48], [1706054400000, 2489.3], [1706140800000, 2273.78], [1706227200000, 2322.64], [1706313600000, 2313.58], [1706400000000, 2261.88], [1706486400000, 2282.45], [1706572800000, 2264.76], [1706659200000, 2427.72], [1706745600000, 2226.49], [1706832000000, 2446.25], [1706918400000, 2413.37], [1707004800000, 2333.55], [1707091200000, 2237.92], [1707177600000, 2319.26], [1707264000000, 2268.6], [1707350400000, 2378.95], [1707436800000, 2465.94], [1707523200000, 2369.13], [1707609600000, 2202.05], [1707696000000, 2417.94], [1707782400000, 2450.94], [1707868800000, 2365.08], [1707955200000, 2299.53], [1708041600000, 2368.45], [1708128000000, 2402.98], [1708214400000, 2308.72], [1708300800000, 2460.95], [1708387200000, 2295.68], [1708473600000, 2264.76], [1708560000000, 2287.09], [1708646400000, 2459.39], [1708732800000, 2321.1], [1708819200000, 2457.18], [1708905600000, 2277.75], [1708992000000, 2400.76], [1709078400000, 2341.02], [1709164800000, 2178.16], [1709251200000, 2380.67], [1709337600000, 2237.02], [1709424000000, 2320.09], [1709510400000, 2446.55], [1709596800000, 2302.56], [1709683200000, 2271.18], [1709769600000, 2288.63], [1709856000000, 2338.9], [1709942400000, 2220.58], [1710028800000, 2510.2], [1710115200000, 2229.18], [1710201600000, 2472.07], [1710288000000, 2322.17], [1710374400000, 2417.53], [1710460800000, 2297.7], [1710547200000, 2325.59], [1710633600000, 2307.22], [1710720000000, 2446], [1710806400000, 2405.15], [1710892800000, 2294.12], [1710979200000, 2410.54], [1711065600000, 2174.52], [1711152000000, 2212.35], [1711238400000, 2292.96], [1711324800000, 2300.15], [1711411200000, 2340.03], [1711497600000, 2298.12], [1711584000000, 2291.58], [1711670400000, 2348.15], [1711756800000, 2276.71], [1711843200000, 2350.78], [1711929600000, 2223.99], [1712016000000, 2428.28], [1712102400000, 2363.6], [1712188800000, 2243.95], [1712275200000, 2396.72], [1712361600000, 2238.7], [1712448000000, 2275.68], [1712534400000, 2459.07], [1712620800000, 2137.49], [1712707200000, 2282.18], [1712793600000, 2319.6], [1712880000000, 2482.14]]
      }
    ],
    importantLinks: [
      {
        text: 'Documentation',
        href: 'https://vuetifyjs.com'
      },
      {
        text: 'Chat',
        href: 'https://community.vuetifyjs.com'
      },
      {
        text: 'Made with Vuetify',
        href: 'https://madewithvuejs.com/vuetify'
      },
      {
        text: 'Twitter',
        href: 'https://twitter.com/vuetifyjs'
      },
      {
        text: 'Articles',
        href: 'https://medium.com/vuetify'
      }
    ],
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com/components/api-explorer'
      },
      {
        text: 'Select a layout',
        href: 'https://vuetifyjs.com/getting-started/pre-made-layouts'
      },
      {
        text: 'Frequently Asked Questions',
        href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions'
      }
    ]
  }),

  computed: {
    isMovil () {
      const aux = !this.$vuetify.breakpoint.mdAndUp
      return aux
    },
    show () {
      return false && this.getCurrentCompany.authorizations === 'admin'
    },
    ...mapGetters('company', ['getCompany', 'getCompanies']),
    ...mapGetters('user', ['getViews']),
    ...mapGetters('user', [
      'getLogged',
      'getUser',
      'getViews',
      'getAuthorizations',
      'getCurrentCompany'
    ])
  },

  components: {
    Chart
  },

  methods: {
    changeCompany (company) {
      this.changeCurrentCompany(company.identification)
        .then(() => {
          const authorizations = this.getUser.companies.find(({ id }) => id === company.identification)?.authorizations
          const authorizationModules = authorizations === 'admin'
            ? views.moduleViews
            : authorizations
          const auth = authorizationModules.includes(this.$router.currentRoute.name) || this.$router.currentRoute.meta.restricted
          if (!auth) {
            this.$router.push('/').catch(() => {})
          }
        })
        .catch((error) => {
          console.error(error)
          this.showError('Ocurrió un error al cambiar de compañia')
        })
    },
    ...mapActions('user', [
      'signOut',
      'changeCurrentCompany'
    ])
  }
}
</script>
<style>
.theme--light.v-btn:hover {
  opacity: 1;
  background-color: #EBF1FF;
}
.v-btn:not(.v-btn--round).v-size--x-large {
  height: max-content;
  border-radius: 1rem;
  justify-content: start;
  padding: 1rem 1.5rem;
}
.v-btn.v-size--x-large {
  font-size: 1.5rem;
}
@media (min-width: 1264px) {
  .container {
    max-width: 1300px;
  }
}
@media (min-width: 1904px) {
    .container {
        max-width: 95%;
    }
}
.v-btn {
  text-transform: none;
  font-family: Roboto;
  letter-spacing: 0.25px;
  height: max-content;
  border-radius: 1rem;
  padding: 1.5rem;
}
</style>
